var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoCamera = function SvgVideoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.625 9.62 3.933-3.933a.625.625 0 0 1 1.067.441v9.484a.625.625 0 0 1-1.067.441l-3.933-3.933M4.25 16.495h7.5a1.875 1.875 0 0 0 1.875-1.875v-7.5a1.875 1.875 0 0 0-1.875-1.875h-7.5A1.875 1.875 0 0 0 2.375 7.12v7.5a1.875 1.875 0 0 0 1.875 1.875Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgVideoCamera;